import React from "react";

class AudienceForSave {
    includeAll = [];
    includeAny = [];
    excludeAll = [];
    excludeAny = [];
    numberRange = [];
    versionRange = [];
    // offerTypeInactiveRule = [];
    // offerTagInactiveRule = [];
    // offerTagNotInProfileRule = [];
    // offerTagsInProfileRule = [];
    // offerInactiveRule = [];
    // offerNotInProfile = [];
    // offerInProfile = [];
    // profileOffset = [];
}
export function prepareParametersForSave(audienceForSave, parameterSet, handleOffers = false) {
    audienceForSave = Object.keys(audienceForSave).length === 0 ? new AudienceForSave() : audienceForSave;

    if (parameterSet.parameterData?.allowedRules?.includes('VERSION_RANGE')) {
        // if (!audienceForSave.versionRange[parameterSet.parameterData.parameterName]) {
        //     audienceForSave.versionRange[parameterSet.parameterData.parameterName] = new NumericRange()
        // }
        let numericRange = {
            parameter: parameterSet.parameterData.name,
            from: parameterSet.paramFromValue,
            to: parameterSet.paramToValue,
            fromIncluded: parameterSet.fromIncl,
            toIncluded: parameterSet.toIncl
        }
        audienceForSave.versionRange.push(numericRange)

        // audienceForSave.versionRange[parameterSet.parameterData.parameterName].parameter = parameterSet.parameterData.parameterName;
        // audienceForSave.versionRange[parameterSet.parameterData.parameterName].from = parameterSet.paramFromValue;
        // audienceForSave.versionRange[parameterSet.parameterData.parameterName].to = parameterSet.paramToValue;
        // audienceForSave.versionRange[parameterSet.parameterData.parameterName].fromIncluded = parameterSet.fromIncl;
        // audienceForSave.versionRange[parameterSet.parameterData.parameterName].toIncluded = parameterSet.toIncl;

    } else if (parameterSet.parameterData?.allowedRules?.includes('NUMBER_RANGE')) {
        // if (!audienceForSave.numberRange[parameterSet.parameterData.parameterName]) {
        //     audienceForSave.numberRange[parameterSet.parameterData.parameterName] = new NumericRange()
        // }
        let numberRange = {
            parameter: parameterSet.parameterData.name,
            from: parameterSet.paramFromValue,
            to: parameterSet.paramToValue,
            fromIncluded: parameterSet.fromIncl,
            toIncluded: parameterSet.toIncl
        }
        audienceForSave.numberRange.push(numberRange)
        // audienceForSave.numberRange[parameterSet.parameterData.parameterName].parameter = parameterSet.parameterData.parameterName;
        // audienceForSave.numberRange[parameterSet.parameterData.parameterName].from = parameterSet.paramFromValue;
        // audienceForSave.numberRange[parameterSet.parameterData.parameterName].to = parameterSet.paramToValue;
        // audienceForSave.numberRange[parameterSet.parameterData.parameterName].fromIncluded = parameterSet.fromIncl;
        // audienceForSave.numberRange[parameterSet.parameterData.parameterName].toIncluded = parameterSet.toIncl;

    } else if (
        parameterSet.parameterData?.allowedRules?.includes('INCLUDE') ||
        parameterSet.parameterData?.allowedRules?.includes('INCLUDE_ALL') ||
        parameterSet.parameterData?.allowedRules?.includes('INCLUDE_ANY') ||
        parameterSet.parameterData?.allowedRules?.includes('EXCLUDE_ANY') ||
        parameterSet.parameterData?.allowedRules?.includes('EXCLUDE_ALL') ||
        parameterSet.parameterData?.allowedRules?.includes('EXCLUDE')
    ) {
        if (!audienceForSave[parameterSet.operator]?.[parameterSet.parameterData.name]) {
            audienceForSave[parameterSet.operator].push({
                parameter: parameterSet.parameterData.name,
                values: typeof parameterSet.paramValue === 'string' ? parameterSet.paramValue.split(',') :
                    parameterSet.paramValue
            })
        }
    } else if (parameterSet.parameterData?.allowedRules?.includes('OFFER_INACTIVE')) {
        audienceForSave.offerInactiveRule.push({
            parameter: 'offer_inactive',
            offerIds: parameterSet.paramValue
        })
    } else if (parameterSet.parameterData?.allowedRules?.includes('TYPE_INACTIVE')) {
        audienceForSave.offerTypeInactiveRule.push({
            parameter: 'type_inactive',
            types: parameterSet.paramValue
        })
    } else if (parameterSet.parameterData?.allowedRules?.includes('TAG_INACTIVE')) {
        audienceForSave.offerTagInactiveRule.push({
            parameter: 'tag_inactive',
            tags: parameterSet.paramValue
        })
    } else if (parameterSet.parameterData?.allowedRules?.includes('TAG_NOT_IN_PROFILE')) {
        audienceForSave.offerTagNotInProfileRule.push({
            parameter: 'tag_not_in_profile',
            tags: parameterSet.paramValue
        })
    } else if (parameterSet.parameterData?.allowedRules?.includes('TAGS_IN_PROFILE')) {
        audienceForSave.offerTagsInProfileRule.push({
            parameter: 'tags_in_profile',
            tags: parameterSet.paramValue
        })
    } else if (parameterSet.parameterData?.allowedRules?.includes('OFFER_IN_PROFILE')) {
        audienceForSave.offerInProfile.push({
            parameter: 'offers_in_profile',
            offerId: parameterSet.paramValue
        })
    } else if (parameterSet.parameterData?.allowedRules?.includes('OFFER_NOT_IN_PROFILE')) {
        audienceForSave.offerNotInProfile.push({
            parameter: 'offers_not_in_profile',
            offerId: parameterSet.paramValue
        })
    } else if (parameterSet.parameterData?.allowedRules?.includes('PROFILE_OFFSET')) {
        let paramName = parameterSet.parameterData.name
        audienceForSave.profileOffset.push({
            offerId: parameterSet.offerId,
            operator: parameterSet.operator,
            offset: parameterSet.offset,
            parameter: paramName
        })
    }

    //checkOffersInAudience(audienceForSave)

    if (handleOffers) {
        _prepareOffers(audienceForSave, parameterSet);
    }

    return audienceForSave;
}


function _prepareOffers (audienceForSave, parameterSet) {
    if (parameterSet.parameterData?.allowedRules?.includes('OFFER_IN_PROFILE')) {
        audienceForSave.offerInProfile = {
            offersInProfile: {
                parameter: 'offers_in_profile',
                offerId: parameterSet.paramValue
            }
        }
    } else if (parameterSet.parameterData?.allowedRules?.includes('OFFER_NOT_IN_PROFILE')) {
        audienceForSave.offerNotInProfile = {
            offersNotInProfile: {
                parameter: 'offers_not_in_profile',
                offerId: parameterSet.paramValue
            }
        }
    } else if (parameterSet.parameterData?.allowedRules?.includes('PROFILE_OFFSET')) {
        let paramName = parameterSet.parameterData.parameterName
        audienceForSave.profileOffset[paramName] = {
            offerId: parameterSet.offerId,
            offset: parameterSet.offset,
            operator: parameterSet.operator,
            parameter: paramName
        }
    }
    //_checkOffersInAudience(audienceForSave)
}

function checkOffersInAudience(audienceForSave) {

    if (!audienceForSave.hasOwnProperty("profileOffset")) {
        audienceForSave.profileOffset = [];
    }
    if (!audienceForSave.hasOwnProperty("offerInProfile")) {
        audienceForSave.offerInProfile = [];
    }
    if (!audienceForSave.hasOwnProperty("offerNotInProfile")) {
        audienceForSave.offerNotInProfile = [];
    }
}

function _checkOffersInAudience(audienceForSave) {

    if (!audienceForSave.hasOwnProperty("profileOffset")) {
        audienceForSave.profileOffset = [];
    }
    if (!audienceForSave.hasOwnProperty("offerInProfile")) {
        audienceForSave.offerInProfile = [];
    }
    if (!audienceForSave.hasOwnProperty("offerNotInProfile")) {
        audienceForSave.offerNotInProfile = [];
    }
}

export function getCtr(item) {
    const totals = item.statistics.reduce((acc, current) => {
        // Проверяем, что значения существуют и являются числами
        const sent = typeof current.sent === 'number' ? current.sent : 0;
        const clicked = typeof current.clicked === 'number' ? current.clicked : 0;

        // Суммируем значения
        acc.totalSent += sent;
        acc.totalClicked += clicked;

        return acc;
    }, { totalSent: 0, totalClicked: 0 });


    return <>
        {totals.totalClicked}/{totals.totalSent} ({totals.totalSent == 0 ?  0 : Math.round(totals.totalClicked/totals.totalSent*1000)/10}%)
    </>

}